// サポーター業務申込フォームの備考欄で、残り入力可能文字数を表示する。
//
// maxlength は IME の変換中には適用されず、確定時にブラウザが文節の途中で切り捨てる。
// IME によっては確定時の改行が残り、上限を超えたままになることもある。
// そこで確定後の値を自前で組み立て、上限を超えるなら変換ごと取り消す
document.addEventListener('turbolinks:load', () => {
  const textarea = document.getElementById('volunteer_task_user_comment');
  const counter = document.getElementById('volunteer_task_user_comment_counter');
  if (!textarea || !counter) return; // このページ以外では何もしない

  const maxLength = Number(textarea.getAttribute('maxlength'));
  let beforeComposition = null; // 変換開始時点の値とカーソル位置

  function updateCounter() {
    const remaining = maxLength - textarea.value.length;
    counter.textContent = `残り${remaining}文字`;
    counter.classList.toggle('text-danger', remaining <= 0);
    counter.classList.toggle('text-muted', remaining > 0);
  }

  textarea.addEventListener('compositionstart', () => {
    beforeComposition = { value: textarea.value, start: textarea.selectionStart, end: textarea.selectionEnd };
  });

  textarea.addEventListener('compositionend', (event) => {
    if (beforeComposition) {
      const { value, start, end } = beforeComposition;
      // 確定時点の値は既にブラウザが切り捨てている場合があるため、確定文字列から本来の値を組み立てる
      const composed = value.slice(0, start) + (event.data || '') + value.slice(end);
      if (composed.length > maxLength) {
        textarea.value = value;
        textarea.setSelectionRange(start, start);
      }
      beforeComposition = null;
    }
    updateCounter();
  });

  textarea.addEventListener('input', updateCounter);

  updateCounter();
});
